import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModuleWithProviders } from '@angular/compiler/src/core';
import { CoreModule } from '../core/core.module';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { VisitorManagementRoutingModule } from './visitor-management-routing.module';
import { VisitorManagementService } from './visitor-management.service';
import { VisitorComponent } from './visitor/visitor.component';
import { VisitorDashboardComponent } from './visitor-dashboard/visitor-dashboard.component';
import { FaceRecognitionUIService } from '../face-recognition/faceRecognitionUI.service';
import { VisitorFormModalComponent } from './visitor-form-modal/visitor-form-modal.component';
import { SignaturepadModule } from './signaturepad/signaturepad.module';
import { VerifyVisitorComponent } from './verify-visitor/verify-visitor.component';
import { PrintRequestComponent } from './print-request/print-request.component';
import { ReadQrCodeComponent } from './read-qr-code/read-qr-code.component';
import { EditorModule } from 'primeng/editor';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { RequestVisitorFormModalComponent } from './request-visitor/request-visitor-form-modal.component';
import { InductionTrainingPaperComponent } from './induction-training-paper/induction-training-paper.component';
import { AfterPreRequestVisitorComponent } from './after-pre-request-visitor/after-pre-request-visitor.component';

@NgModule({
  exports: [
    VisitorManagementRoutingModule
  ],
  declarations: [
    VisitorComponent,
    VisitorDashboardComponent,
    VisitorFormModalComponent,
    VerifyVisitorComponent,
    RequestVisitorFormModalComponent,
    PrintRequestComponent,
    ReadQrCodeComponent,
    InductionTrainingPaperComponent,
    AfterPreRequestVisitorComponent
    // FaceRecognitionUIComponent,
    // FaceRecognizatonComponent,
    // FaceTrainCameraComponent,
    // FaceTrainImageFileComponent
  ],
  imports: [
    CommonModule,
    VisitorManagementRoutingModule,
    CoreModule.forRoot(),
    SweetAlert2Module,
    EditorModule,
    ZXingScannerModule,
    SignaturepadModule
  ],
  providers: [
    VisitorManagementService,
    FaceRecognitionUIService
  ],
  entryComponents: [
    VisitorFormModalComponent,
    VerifyVisitorComponent,
    RequestVisitorFormModalComponent
  ]

})
export class VisitorManagementModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: VisitorManagementModule,
      providers: [
        VisitorManagementService,
      ]
    };
  }
}
